const styles = theme => ({
  bannerBg: {
    backgroundColor: "#F2F5FF",
    width: "100%",
    height: "211px",
    display: "flex",
    alignItems: "center",
    padding: "0px 15%",
    borderRadius: "0 0 50px 0",
    ["@media (max-width:576px)"]: {
      padding: "0px 5%"
    }
  },
  heading: {
    ...theme.typography.faqFont,
    color: "#2E2E36",
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: 700,
    margin: "0 0 20px 0",
    padding: "0",
    ["@media (max-width:576px)"]: {
      fontSize: "30px",
      lineHeight: "36px"
    }
  },
  subHeading: {
    ...theme.typography.faqFont,
    color: "#2E2E36",
    margin: "0",
    padding: "0",
    fontSize: "16px",
    lineHeight: "19px",
    ["@media (min-width:576px)"]: { marginRight: "200px" }
  },
  email: {
    ...theme.typography.faqFont,
    color: "#2A89F6",
    fontSize: "13px",
    textDecoration: "none",
    fontWeight: 600,
    outline: "none",
    ["@media (max-width:576px)"]: {
      display: "flex",
      marginTop: "5px"
    }
  },
  rightAlign: {
    display: "flex",
    justifyContent: "end",
    ["@media (max-width:576px)"]: {
      display: "none"
    }
  },
  bannerImage: {
    position: "relative",
    top: "-30px"
  },
  faqContainer: {
    padding: "10px 15%",
    display: "flex",
    flexDirection: "row",
    ["@media (max-width:576px)"]: {
      padding: "0px 5%",
      flexDirection: "column"
    }
  },
  faqTab: {
    ["@media (max-width:576px)"]: {
      overflowX: "scroll",
      borderBottom: "1px solid #D2D5E1",
      margin: "0px -5% 20px -5%",
      whiteSpace: "nowrap",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { width: 0, height: "0" }
    }
  },

  menuItem: {
    ...theme.typography.faqFont,
    color: "#2E2E36",
    fontSize: "16px",
    lineHeight: "40px",
    fontWeight: 600,
    borderBottom: "1px solid #D2D5E1",
    marginRight: "40px",
    cursor: "pointer",
    outline: "none",
    display: "block",
    textDecoration: "none",
    ["@media (max-width:576px)"]: {
      margin: "0 0 0 20px",
      borderBottom: "none",
      padding: "0",
      display: "inline-block"
    },
    "&:focus": {
      outline: "none !important"
    }
  },
  activeMenuItem: {
    borderBottom: "3px solid #FFB3B5",
    padding: "0 0 7px 0",
    borderRadius: "55px 55px 0 0"
  },
  faqList: {
    marginBottom: "40px"
  },
  marginTop: {
    marginTop: "350px"
  },
  catTitle: {
    ...theme.typography.faqFont,
    display: "flex",
    alignItems: "center",
    color: "#2E2E36",
    fontSize: "18px",
    lineHeight: "22px",
    fontWeight: 600,
    margin: "9px 0",
    "& img": {
      width: "22px",
      marginRight: "7px"
    }
  },

  stickyClass: {
    top: "90px",
    zIndex: 1,
    height: "100%",
    position: "sticky",
    ["@media (max-width:576px)"]: {
      height: "80px",
      top: "70px",
      padding: "15px 0px",
      backgroundColor: "#ffffff"
    }
  },
  breadcrumbs: {
    padding: "0px 15%",
    ["@media (max-width:576px)"]: {
      padding: "0px 5%"
    }
  },
  scrollHeight: {
    height: "85px",
    ["@media (max-width:576px)"]: {
      height: "140px"
    }
  },
  categoryName: {
    color: "#2E2E36",
    fontSize: "18px",
    lineHeight: "22px",
    fontWeight: 600,
    margin: 0
  },
  faqSection: {
    scrollMarginTop: "270px"
  },
  cont1: {
    display: "flex",
    flexDirection: "column"
  },
  ["@media (min-width:576px)"]: {
    faqContainerLeft: {
      flexBasis: "25%"
    },
    faqContainerRight: {
      flexBasis: "75%"
    },
    cont1: {
      "& .cont1-left": {
        flexBasis: "66.66%"
      },
      "& .cont1-right": {
        flexBasis: "33.33%",
        position: "relative",
        top: "15px"
      }
    }
  }
});

export default styles;
